import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import EllieTip from "../atoms/EllieTip";

import "./EllieTips.css";

export const EllieTips = () => {
  return (
    <div id="ellietips">
      <h1 style={{ marginBottom: "30px" }}>Ellie Tips!</h1>

      <div
        className="ellietips-container"
        style={{ width: "100%", /*minWidth: "350px"*/}}
      >
        <Swiper
          initialSlide={1}
          effect={"cards"}
          slidesPerView={"auto"}
          centeredSlides={true}
          modules={[EffectCards, Pagination]}
          pagination={{ clickable: true }}
          cardsEffect={{ perSlideOffset: 20, perSlideRotate: 5 }}
        >
          <SwiperSlide>
            <EllieTip
              tip={
                "Cuando actives el Botón de Ayuda, detectemos una caída, o veamos que algún parámetro médico se va de escala, nuestro Ellie Center activará el protocolo de asistencia y prevención más adecuado. También tu red de ayuda estará notificada rápidamente cuando necesites asistencia."
              }
            />
          </SwiperSlide>
          <SwiperSlide>
            <EllieTip
              tip={
                "Para invitar a tu Red de Ayuda te recomendamos familiares, un vecino, algún amigo, o tu medico personal. Lo importante es que vivan cerca tuyo, sean de tu confianza, y que puedan asistirte rápidamente."
              }
            />
          </SwiperSlide>
          <SwiperSlide>
            <EllieTip
              tip={
                "Cuando salgas a caminar, cuando voyas al cine, cuando hagas ejercicio o participes de los Ellie Challenge. Con el Plan GOLD de Ellie Care sumás más puntos, de manera más divertida, y accedés a beneficios únicos!"
              }
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default EllieTips;
